import {
  faUser,
  faEnvelope,
  faLock,
  faSignIn,
  faPlay,
  faUserTie,
  faHeadset,
  faShieldHalved,
  faClock,
  faUserPlus,
  faCheck,
  faTimes,
  faKey,
  faEye,
  faEyeSlash,
  faMapMarkerAlt,
  faPhone,
  faComment,
  faBell,
  faClockRotateLeft,
  faCircle,
  faListCheck,
  faArrowRotateRight,
  faStar,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

export const Assets = {
  LOGO: {
    TAX_LINK: 'assets/images/logo/comply-desk-light-logo.png',
  },
  IMAGES: {},
  ILLUSTRATIONS: {},
  ICONS: {
    CLOSE: { name: 'close', url: '/assets/icons/close.svg' },
    LINE: { name: 'line', url: '/assets/icons/line.svg' },
    CHEVRON_LEFT: { name: 'chevron-left', url: '/assets/icons/chevron-left.svg' },
    CHEVRON_RIGHT: { name: 'chevron-right', url: '/assets/icons/chevron-right.svg' },
    CHEVRON_DOWN: { name: 'chevron-down', url: '/assets/icons/chevron-down.svg' },
    MOBILE_CANCEL: { name: 'mobile-cancel', url: '/assets/icons/cancel.svg' },
  },
  FA_ICONS: {
    user: { icon: faUser, name: 'user' },
    envelope: { icon: faEnvelope, name: 'envelope' },
    lock: { icon: faLock, name: 'lock' },
    signIn: { icon: faSignIn, name: 'sign-in' },
    play: { icon: faPlay, name: 'play' },
    userTie: { icon: faUserTie, name: 'user-tie' },
    headSet: { icon: faHeadset, name: 'headset' },
    shieldHalved: { icon: faShieldHalved, name: 'shield-halved' },
    clock: { icon: faClock, name: 'clock' },
    userPlus: { icon: faUserPlus, name: 'user-plus' },
    check: { icon: faCheck, name: 'check' },
    star: { icon: faStar, name: 'star' },
    times: { icon: faTimes, name: 'times' },
    key: { icon: faKey, name: 'key' },
    eye: { icon: faEye, name: 'eye' },
    eyeSlash: { icon: faEyeSlash, name: 'eye-slash' },
    mapMarkerAlt: { icon: faMapMarkerAlt, name: 'map-marker-alt' },
    phone: { icon: faPhone, name: 'phone' },
    facebook: { icon: faFacebook, name: 'facebook' },
    instagram: { icon: faInstagram, name: 'instagram' },
    xTwitter: { icon: faXTwitter, name: 'x-twitter' },
    linkedin: { icon: faLinkedin, name: 'linkedin' },
    youtube: { icon: faYoutube, name: 'youtube' },
    comment: { icon: faComment, name: 'comment' },
    bell: { icon: faBell, name: 'bell' },
    clockRotateLeft: { icon: faClockRotateLeft, name: 'clock-rotate-left' },
    circle: { icon: faCircle, name: 'circle' },
    listCheck: { icon: faListCheck, name: 'list-check' },
    arrowRotateRight: { icon: faArrowRotateRight, name: 'arrow-rotate-right' },
  },
};
